import moment from 'moment';

const getDepartureDateTime = ({ model }) =>
  model.commercialDepartureDateTime || model.scheduledDepartureDateTime || model.expectedDepartureDateTime || model.actualDepartureDateTime;

const getServiceNews = (serviceStops) => {
  const newsById = serviceStops.reduce((allNews, { news = [] }) => {
    news.forEach((newsItem) => {
      allNews[newsItem.model.id] = newsItem;
    });

    return allNews;
  }, {});

  return Object.values(newsById);
};

const prepareService = (service) => {
  const serviceStops = [...service.serviceStops].sort(
    ({ model: { stopNumber: stopNumberA } }, { model: { stopNumber: stopNumberB } }) => stopNumberA - stopNumberB
  );
  const origin = serviceStops[0];
  const destination = serviceStops[serviceStops.length - 1];
  const departureDateTime = getDepartureDateTime(origin);
  const serviceDate = origin.model.date || departureDateTime;

  return {
    date: moment(serviceDate).format('YYYY-MM-DD'),
    departureDateTime,
    train: {
      model: service.model,
      origin,
      destination,
      serviceStops,
      news: getServiceNews(serviceStops)
    }
  };
};

export const groupAffectedServicesByDate = (services = []) => {
  const servicesByDate = services.reduce((groups, service) => {
    if (!service.serviceStops?.length) {
      return groups;
    }

    const preparedService = prepareService(service);

    if (!groups[preparedService.date]) {
      groups[preparedService.date] = [];
    }

    groups[preparedService.date].push(preparedService);

    return groups;
  }, {});

  return Object.keys(servicesByDate)
    .sort()
    .map((date) => ({
      date,
      services: servicesByDate[date]
        .sort((serviceA, serviceB) => moment(serviceA.departureDateTime).valueOf() - moment(serviceB.departureDateTime).valueOf())
        .map(({ train }) => train)
    }));
};
